/**************************************************
 * Nombre:       Home_Sistema
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../.././../Recursos/video_sistema.mp4'
import meet from '../.././../Recursos/ic_meet.svg'
import zoom from '../.././../Recursos/ic_zoom.svg'
import teams from '../.././../Recursos/ic_teams.svg'
import drive from '../.././../Recursos/ic_drive.svg'
import you from '../.././../Recursos/ic_you.svg'
import compu from '../.././../Recursos/computador.png'
import {GRADIENTE, URLUSUARIO} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";

const Home_Sistema = () => {
    const {sCell, sTab, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{overflowX: 'hidden'}}
        >


            <video width={'100%'} height={sTab ? 620 : 720}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1
                   }}
                   id="background-video" autoPlay loop muted>
                <source src={fondo} type="video/mp4"/>
            </video>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: sCell ? -81 : sTab ? -66 : -72, zIndex: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{color: '#262626', fontSize: sCell ? 32 : 40, fontWeight: 700}}>
                                        Sistema Educativo
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{color: '#545454', fontSize: 16, fontWeight: 400}}>
                                        La formación combina mentorías, práctica y experiencias transformadoras para
                                        ayudarte a construir un negocio sólido y con propósito, creciendo junto a otros
                                        que también decidieron avanzar.
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={2}
                                    >

                                        <Button
                                            onClick={() => irUrl(URLUSUARIO + 'registro')}
                                            variant={'outlined'}> Registro</Button>

                                        <Button
                                            onClick={() => irUrl(URLUSUARIO + 'ingreso')}
                                            sx={{background: GRADIENTE}}> Ingresar</Button>

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={4}
                                    >

                                        {logos.map(logo => (
                                            <img src={logo} height={!masSM ? 24 : 32} width={'auto'}/>
                                        ))}

                                    </Grid>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 7}}
                              sx={{
                                  justifyContent: 'flex-start',
                                  mr: sCell ? 0 : -16,
                                  ml: sCell ? 0 : 16,
                                  mt: sCell ? 8 : 0
                              }}>
                            <img src={compu} width={sCell ? '100%' : '118%'} height={'auto'}/>
                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Sistema

const logos = [meet, zoom, teams, drive, you]